import firebase_app from "../configs";
import {
  GoogleAuthProvider,
  getAdditionalUserInfo,
  getAuth,
  signInWithPopup,
} from "firebase/auth";

const auth = getAuth(firebase_app);
const provider = new GoogleAuthProvider();

export default async function signUpWithGoogle() {
  var user = null,
    error = null,
    userInfo = null,
    credential = null;
  try {
    await signInWithPopup(auth, provider)
      .then(async (result) => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        user = result.user;
        userInfo = await getAdditionalUserInfo(result);
      })
      .catch((error) => {
        // Handle Errors here.
        // const errorCode = error.code;
        // const errorMessage = error.message;
        // // The email of the user's account used.
        // const email = error.customData.email;
        // The AuthCredential type that was used.
        credential = GoogleAuthProvider.credentialFromError(error);
      });
  } catch (error) {}
  return { user, error, userInfo, result: credential };
}
